import React, { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { observer } from "mobx-react";
import { Outlet, useMatchRoute } from "@tanstack/react-router";
import { ChakraProvider } from "@chakra-ui/react";
import { Layout } from "../Layout/Layout";
import { ScrollManager } from "../ScrollManager";
import { RouteTestOverlay } from "../RouteTestOverlay";
import { LeavingModal } from "../LeavingModal";
import { theme } from "@/styles/theme";
import { analytics } from "@/analytics/ga";
import { WelcomePage } from "@/pages/Welcome";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { appEnv } from "@/constants/env";

export const App = observer(() => {
  const matchRoute = useMatchRoute();
  const isHomePage = matchRoute({ to: "/" });

  useEffect(() => {
    analytics.initialize();
  }, []);

  return (
    <GoogleReCaptchaProvider reCaptchaKey={appEnv.recaptchaKey}>
      <ChakraProvider theme={theme}>
        <Layout>
          {isHomePage ? <WelcomePage /> : <Outlet />}
          <ScrollManager />
          <RouteTestOverlay />
          <LeavingModal />
          <Toaster
            containerStyle={{
              top: 100,
            }}
          />
        </Layout>
      </ChakraProvider>
    </GoogleReCaptchaProvider>
  );
});
